import "../styles/connectfour.css"
import { useImperativeHandle, useState } from "preact/hooks"
import { Colors } from "./enum/Players"
import { forwardRef } from "preact/compat"

export default forwardRef(({}, ref) => {

    const [color, setColor] = useState(null)

    useImperativeHandle(ref, () => ({
        toggle(colorSet = null) {
            setColor(colorSet)
        }
    }))

    return color ? <div className = "circle" style={{ background: Colors[color] }}></div> : <div className = "invisibleCell"></div>
})